// export const ICON_URL = {
//   url: directory_uri.template_uri + '/assets/icons/marker.svg', // SVG ICON URL HERE
//   scaledSize: new google.maps.Size(30, 50),
//   origin: new google.maps.Point(0, 0)
// }
//
// export const MAP_STYLE = [
//   // PASTE MAP STYLE FROM https://snazzymaps.com/
// ]



// WEBPACK FOOTER //
// ./src/js/components/constants.js